import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddingUserFailed = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 200,
	height: 140,
	viewBox: "0 0 200 140",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 200,
			height: 140,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 89.6406,
			cy: 120.66,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40.6406,
			cy: 35.6602,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97 73H121",
			stroke: "url(#paint0_linear_8280_29632)",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M97 91H121",
			stroke: "url(#paint1_linear_8280_29632)",
			strokeWidth: 6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M105 37C105 39.7614 102.761 42 100 42C97.2386 42 95 39.7614 95 37C95 34.2386 97.2386 32 100 32C102.761 32 105 34.2386 105 37Z",
			fill: "url(#paint2_linear_8280_29632)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M89.1382 26.1623C69.7027 44.467 64.4613 58.2684 48.8132 66.5333C38.8632 71.7886 27.4076 75.6469 21.53 85.2424C0.121438 120.193 45.7558 148.941 75.1378 114.66C100.056 85.5876 138.265 153 174.637 98.1602C207.137 49.1608 140.637 -22.3407 89.1382 26.1623Z",
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 89.6406,
			cy: 120.66,
			r: 6,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 40.6406,
			cy: 35.6602,
			r: 8,
			fill: "#F0FAF8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M100 30.5C121.815 30.5 139.5 48.1848 139.5 70C139.5 91.8153 121.815 109.5 100 109.5C78.1848 109.5 60.5 91.8153 60.5 70C60.5 48.1848 78.1848 30.5 100 30.5Z",
			fill: "url(#paint3_linear_8280_29632)",
			stroke: "url(#paint4_linear_8280_29632)"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 99.9994,
			cy: 59.5833,
			rx: 8.33333,
			ry: 8.33333,
			fill: "url(#paint5_linear_8280_29632)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M116.667 79.375C116.667 84.5527 116.667 88.75 100.001 88.75C83.334 88.75 83.334 84.5527 83.334 79.375C83.334 74.1973 90.7959 70 100.001 70C109.205 70 116.667 74.1973 116.667 79.375Z",
			fill: "url(#paint6_linear_8280_29632)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M116.667 60.104C117.53 60.104 118.229 60.8036 118.229 61.6665V64.2707H120.833C121.696 64.2707 122.396 64.9703 122.396 65.8332C122.396 66.6962 121.696 67.3957 120.833 67.3957H118.229L118.229 69.9998C118.229 70.8628 117.53 71.5623 116.667 71.5623C115.804 71.5623 115.104 70.8628 115.104 69.9998V67.3957H112.5C111.637 67.3957 110.938 66.6962 110.938 65.8332C110.938 64.9703 111.637 64.2707 112.5 64.2707H115.104V61.6665C115.104 60.8036 115.804 60.104 116.667 60.104Z",
			fill: "url(#paint7_linear_8280_29632)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.333 93.9998C137.333 101.364 131.363 107.333 123.999 107.333C116.636 107.333 110.666 101.364 110.666 93.9998C110.666 86.636 116.636 80.6665 123.999 80.6665C131.363 80.6665 137.333 86.636 137.333 93.9998Z",
			fill: "#DB5543",
			stroke: "white",
			strokeWidth: 1.5,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M124 86.3335C124.552 86.3335 125 86.7812 125 87.3335V95.3335C125 95.8858 124.552 96.3335 124 96.3335C123.448 96.3335 123 95.8858 123 95.3335V87.3335C123 86.7812 123.448 86.3335 124 86.3335ZM124 98.3335C124.552 98.3335 125 98.7812 125 99.3335V100.667C125 101.219 124.552 101.667 124 101.667C123.448 101.667 123 101.219 123 100.667V99.3335C123 98.7812 123.448 98.3335 124 98.3335Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_8280_29632",
				x1: 97,
				y1: 73.5,
				x2: 121,
				y2: 73.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_8280_29632",
				x1: 97,
				y1: 91.5,
				x2: 121,
				y2: 91.5,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4C1DC8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_8280_29632",
				x1: 100,
				y1: 32,
				x2: 100,
				y2: 42,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint3_linear_8280_29632",
				x1: 100,
				y1: 30,
				x2: 100,
				y2: 110,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint4_linear_8280_29632",
				x1: 100,
				y1: 30,
				x2: 100,
				y2: 110,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#865E9C" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#B69CC4"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint5_linear_8280_29632",
				x1: 99.9993,
				y1: 51.25,
				x2: 99.9993,
				y2: 67.9167,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint6_linear_8280_29632",
				x1: 100.001,
				y1: 70,
				x2: 100.001,
				y2: 88.75,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#6BCABA" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#ACE1D8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint7_linear_8280_29632",
				x1: 116.667,
				y1: 60.104,
				x2: 116.667,
				y2: 71.5623,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#250E62" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#471BBB"
				})]
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgAddingUserFailed);
export { ForwardRef as ReactComponent };
